module.exports = __webpack_public_path__ + "static/media/map.2bdbea4b.svg";